export default __webpack_public_path__ + "static/media/scrumptious-assortment.4544d27e.png";